/* GTH — add to cart without leaving the page.
 *
 * Why this exists: the theme ships a full cart drawer (snippets/cart-drawer.liquid)
 * but nothing renders it, so the header's data-drawer-toggle="drawer-cart" links
 * fall through to href="/cart" and every add is a full page jump. Until the real
 * drawer is switched on, this gives gth-* sections a stay-on-page add.
 *
 * Opt in per form:  <form ... data-gth-cart>
 * Optional label:   <button data-added-label="Added">
 *
 * IMPORTANT — the header shows the cart count in TWO places and they are not the
 * same markup. Mobile is `.cart-button .count`; desktop is
 * `.navlink--cart [data-header-cart-count]`. Updating only one is why the count
 * appeared stuck on desktop. Both are covered below.
 */
(function () {
  if (window.GTHCart) return;

  var COUNT_SEL = [
    '[data-header-cart-count]',
    '[data-drawer-toggle="drawer-cart"] .count',
    '.cart-button .count'
  ].join(', ');

  var RESET_MS = 2200;

  function refreshCount() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart read failed');
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll(COUNT_SEL).forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(
          new CustomEvent('gth:cart:updated', { detail: cart })
        );
        return cart;
      });
  }

  function submitButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.hasAttribute('data-gth-cart')) return;

    var btn = submitButton(form);
    if (!btn || btn.disabled) return;

    e.preventDefault();

    var label = btn.textContent;
    var addedLabel = btn.getAttribute('data-added-label') || 'Added';

    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding-label') || 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(refreshCount)
      .then(function () {
        btn.textContent = addedLabel;
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = label;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, RESET_MS);
      })
      .catch(function () {
        /* Never lose the add — hand it back to the browser. */
        btn.textContent = label;
        btn.disabled = false;
        btn.removeAttribute('data-gth-cart');
        form.removeAttribute('data-gth-cart');
        form.submit();
      });
  }

  /* Capture phase, bound to document, so dynamically injected cards
     (e.g. Boost-rendered collection grids) are covered without rebinding. */
  document.addEventListener('submit', onSubmit, true);

  window.GTHCart = { refreshCount: refreshCount, countSelector: COUNT_SEL };
})();